import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Created by <b><a href="https://wrt.ie" target="_blank">White Rabbit Technologies Ltd</a></b> 2019</span>
    <div class="socials">
    <a href="https://www.facebook.com/whiterabbittechnologies/" target="_blank" class="ion ion-social-facebook"></a>  
      <!-- <a href="#" target="_blank" class="ion ion-social-github"></a>  
      <a href="#" target="_blank" class="ion ion-social-twitter"></a> -->
      <a href="http://linkedin.com/company/wrt-eng" target="_blank" class="ion ion-social-linkedin"></a>
      
    </div>
  `,
})
export class FooterComponent {
}
